var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSecureBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9C\xD0\xB0\xD0\xBB\xD0\xB5\xD0\xBD\xD1\x8C\xD0\xBA\xD0\xB8\xD0\xB5 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 / \xD0\x91\xD0\xB5\xD0\xB7\xD0\xBE\xD0\xBF\xD0\xB0\xD1\x81\xD0\xBD\xD0\xBE\xD1\x81\xD1\x82\xD1\x8C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.20833 14.5H2.375C1.545 14.5 0.875 13.83 0.875 13V2.5C0.875 1.67 1.545 1 2.375 1H17.375C18.205 1 18.875 1.67 18.875 2.5V7M0.875 5.5H18.875M8.875 10.6C11.145 11.115 13.905 10.335 16.875 9C19.845 10.335 22.605 11.115 24.875 10.6V15.24C24.875 19.985 21.525 24.07 16.875 25C12.225 24.07 8.875 19.985 8.875 15.24V10.6Z",
    stroke: "#AAACAB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSecureBold);
export default __webpack_public_path__ + "static/media/card-secure-bold.6dc65f296c93a7c2ecbd1b5fca69ba2f.svg";
export { ForwardRef as ReactComponent };